import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
// @ts-ignore
const logoCentralis = require('../../assets/logo/logo-centralis-gris.png');
// @ts-ignore
const bandeauCentralis = require('../../assets/logo/bandeau-centralis.png');

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFDFC'
  },
  bandeau: {
    width: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    paddingBottom: 16
  },
  logo: {
    width: 100,
    marginRight: 16
  },
  userInfo: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  dateInfo: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'right',
    marginTop: 4
  },
  infoSection: {
    padding: 16,
    marginHorizontal: 24,
    marginBottom: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 8
  },
  infoLabel: {
    fontWeight: 'bold',
    width: '40%',
    fontSize: 11
  },
  infoValue: {
    flex: 1,
    fontSize: 11
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    padding: 12,
    marginHorizontal: 24,
    marginTop: 16,
    marginBottom: 8,
    borderRadius: 8
  },
  sectionContent: {
    marginHorizontal: 24,
    marginBottom: 16
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 4
  },
  fieldValue: {
    fontSize: 11,
    marginBottom: 12,
    lineHeight: 1.4
  },
  prestaComparison: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 12
  },
  prestaColumn: {
    flex: 1,
    padding: 8
  },
  prestaHeader: {
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    paddingBottom: 8,
    marginBottom: 8
  },
  prestaName: {
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: 4
  },
  prestaDate: {
    fontSize: 10,
    color: '#6B7280'
  },
  responseTechnique: {
    fontSize: 10,
    marginBottom: 8,
    marginTop: 4
  },
  critereTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginTop: 6,
    marginBottom: 2
  },
  critereResponse: {
    fontSize: 9,
    marginBottom: 6,
    lineHeight: 1.3
  },
  noteSection: {
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    marginTop: 8
  },
  noteTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 4
  },
  noteValue: {
    fontSize: 10,
    marginBottom: 2
  },
  notesGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
    gap: 5
  },
  noteItem: {
    flex: 1
  },
  noteLabel: {
    fontSize: 9,
    color: '#6B7280',
  },
  financeTable: {
    marginTop: 10,
    fontSize: 10
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    paddingVertical: 4
  },
  tableHeaderRow: {
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    fontWeight: 'bold'
  },
  tableCell: {
    flex: 1,
    padding: 4
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 6,
    marginTop: 4,
    fontWeight: 'bold',
    fontSize: 10
  },
  synthesisSectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 6,
    padding: 6,
    borderRadius: 4
  },
  bestPresta: {

  },
  selectedPresta: {
    borderWidth: 2,
    borderColor: '#004681',
    borderRadius: 8,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 24,
    right: 24,
    fontSize: 10,
    color: '#6B7280',
    textAlign: 'center',
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB'
  },
  statusBadge: {
    marginVertical: 4,
    padding: 6,
    width: 120,
    textAlign: 'center',
    borderRadius: 20,
    fontSize: 10,
    fontWeight: 'bold'
  },
});

interface AnalyseRecapPDFProps {
  commande: any;
  user: any;
  techNotes: any;
  calculateFinancialScore: (prestataires: any[]) => { [id: string]: number };
  getNoteGlobale: (techNotes: any, prestaId: string) => string;
  selectedPrestataire: number | null;
}

const AnalyseRecapPDF: React.FC<AnalyseRecapPDFProps> = ({
  commande,
  user,
  techNotes,
  calculateFinancialScore,
  getNoteGlobale,
  selectedPrestataire
}) => {

  console.log("Rendering PDF with commande:", commande);
  console.log("Tech Notes:", techNotes);
  console.log("Selected Prestataire:", selectedPrestataire);
  console.log("User:", user);
  const today = new Date().toLocaleDateString('fr-FR');


  // Calculer les scores financiers
  const financialScores = calculateFinancialScore(commande.prestataires || []);

  // Trouver le meilleur prestataire (note totale la plus élevée)
  let bestPrestaId = 0;
  let bestScore = 0;

  if (commande.prestataires && commande.prestataires.length > 0) {
    commande.prestataires.forEach((presta: any, idx: number) => {
      const id = idx.toString();
      const techScore = techNotes[id] ? parseFloat(getNoteGlobale(techNotes, id)) : 0;
      const finScore = financialScores[id] !== undefined ? financialScores[id] : 0;
      const totalScore = (techScore * 0.55) + (finScore * 0.45); // Pondération 55/45

      if (totalScore > bestScore) {
        bestScore = totalScore;
        bestPrestaId = idx;
      }
    });
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Bandeau Centralis */}
        <Image src={bandeauCentralis} style={styles.bandeau} />

        {/* En-tête avec informations utilisateur et date */}
        <View style={styles.header}>
          <View>
            <Text style={styles.userInfo}>{user?.nom || 'Utilisateur'}</Text>
            <Text style={styles.dateInfo}>Document généré le {today}</Text>
          </View>
        </View>

        {/* Informations générales */}
        <View style={styles.infoSection}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>{commande.titre || 'Consultation'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>
              N° {commande.numeroDeCommande || `MS-${commande.id}`} • {commande.type || 'MS'}
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Lot technique:</Text>
            <Text style={styles.infoValue}>{commande.lot_technique.id || '-'} - {commande.lot_technique.nom}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Lot géographique:</Text>
            <Text style={styles.infoValue}>{commande.id_lot_departement || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date de création:</Text>
            <Text style={styles.infoValue}>
              {commande.created_at
                ? new Date(commande.created_at).toLocaleDateString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
                : today}
            </Text>
          </View>
        </View>

        {/* Analyse de l'offre technique */}
        <Text style={styles.sectionTitle}>Analyse de l'offre technique</Text>
        <View style={styles.sectionContent}>
          <View style={styles.prestaComparison}>
            {commande.commandes && commande.commandes.map((presta: any, idx: number) => {
              const isSelected = selectedPrestataire === idx;
              const isBest = idx === bestPrestaId;
              const isExpired = presta.id_status === 12;


              return (
                <View
                  key={`tech-${idx}`}
                  style={[
                    styles.prestaColumn,
                    isSelected ? styles.selectedPresta : null,
                    isBest ? styles.bestPresta : null
                  ]}
                >
                  <View style={styles.prestaHeader}>
                    <Text style={styles.prestaName}>{presta.nom_entite}</Text>
                    <Text style={styles.prestaDate}>
                      Candidature reçue le&nbsp;
                      {presta.created_at
                        ? new Date(presta.created_at).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric"
                        })
                        : today}
                    </Text>
                  </View>

                  <Text style={styles.critereTitle}>Réponse Technique:</Text>
                  <Text style={styles.responseTechnique}>
                    {(presta.reponse || "").substring(0, 200)}
                    {(presta.reponse || "").length > 200 ? "..." : ""}
                  </Text>

                  {/* Humain */}
                  <Text style={styles.critereTitle}>Humain : {techNotes[idx.toString()]?.organisation?.description || "-"}</Text>
                  <Text style={{ fontSize: 10, color: '#6B7280', marginBottom: 6 }}>
                    Commentaire : {techNotes[idx.toString()]?.organisation?.commentaire || "-"}
                  </Text>

                  {/* Environnement */}
                  <Text style={styles.critereTitle}>Environnement : {techNotes[idx.toString()]?.social?.description || "-"}</Text>
                  <Text style={{ fontSize: 10, color: '#6B7280', marginBottom: 6 }}>
                    Commentaire : {techNotes[idx.toString()]?.social?.commentaire || "-"}
                  </Text>

                  {/* Opérationnel */}
                  <Text style={styles.critereTitle}>Opérationnel : {techNotes[idx.toString()]?.moyens?.description || "-"}</Text>
                  <Text style={{ fontSize: 10, color: '#6B7280', marginBottom: 6 }}>
                    Commentaire : {techNotes[idx.toString()]?.moyens?.commentaire || "-"}
                  </Text>

                  {/* Notes */}
                  <View style={styles.noteSection}>
                    <Text style={styles.noteTitle}>Notes:</Text>
                    <View style={styles.notesGrid}>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Humain</Text>
                        <Text style={styles.noteValue}>
                          {techNotes[idx.toString()]?.organisation?.note || "0"}/5
                        </Text>
                      </View>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Environnement</Text>
                        <Text style={styles.noteValue}>
                          {techNotes[idx.toString()]?.social?.note || "0"}/1
                        </Text>
                      </View>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Opérationnel</Text>
                        <Text style={styles.noteValue}>
                          {techNotes[idx.toString()]?.moyens?.note || "0"}/4
                        </Text>
                      </View>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Global</Text>
                        <Text style={styles.noteValue}>
                          {getNoteGlobale(techNotes, idx.toString())}/10
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        </View>

        {/* Analyse de l'offre financière */}
        <Text style={styles.sectionTitle}>Analyse de l'offre financière</Text>
        <View style={styles.sectionContent}>
          <View style={styles.prestaComparison}>
            {commande.commandes && commande.commandes.map((presta: any, idx: number) => {
              const isSelected = selectedPrestataire === idx;
              const isBest = idx === bestPrestaId;

              return (
                <View
                  key={`finance-${idx}`}
                  style={[
                    styles.prestaColumn,
                    isSelected ? styles.selectedPresta : null,
                    isBest ? styles.bestPresta : null
                  ]}
                >
                  <View style={styles.prestaHeader}>
                    <Text style={styles.prestaName}>{presta.nom_entite}</Text>
                  </View>

                  <View style={styles.financeTable}>
                    <View style={[styles.tableRow, styles.tableHeaderRow]}>
                      <Text style={styles.tableCell}>Article</Text>
                      <Text style={styles.tableCell}>Prix HT</Text>
                    </View>

                    {presta.sections?.map((section: any) =>
                      section.articles?.map((article: any) => (
                        <View style={styles.tableRow} key={article.id}>
                          <Text style={styles.tableCell}>{article.nom}</Text>
                          <Text style={styles.tableCell}>
                            {article.prix.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                          </Text>
                        </View>
                      ))
                    )}

                    <View style={styles.totalRow}>
                      <Text>Total HT: {presta.prix_total?.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</Text>
                    </View>
                  </View>

                  <View style={styles.noteSection}>
                    <Text style={styles.noteTitle}>Note financière: {presta.note_financiere || 0}/10</Text>
                  </View>
                </View>
              );
            })}
          </View>
        </View>

        {/* Synthèse de l'analyse */}
        <Text style={styles.sectionTitle}>Synthèse de l'analyse des offres</Text>
        <View style={styles.sectionContent}>
          <Text style={styles.synthesisSectionTitle}>Comparaison des offres</Text>

          <View style={styles.prestaComparison}>
            {commande.commandes && commande.commandes.map((presta: any, idx: number) => {
              const isSelected = selectedPrestataire === idx;
              const isBest = idx === bestPrestaId;

              const techScore = getNoteGlobale(techNotes, idx.toString()) || 0;
              const finScore = presta.note_financiere || 0;
              const totalScore = (Number(techScore) * 0.55) + (finScore * 0.45);

              return (
                <View
                  key={`synthese-${idx}`}
                  style={[
                    styles.prestaColumn,
                    isSelected ? styles.selectedPresta : null,
                    isBest ? styles.bestPresta : null
                  ]}
                >
                  <View style={styles.prestaHeader}>
                    <Text style={styles.prestaName}>{presta.nom_entite}</Text>
                    {isBest && (
                      <Text style={[styles.prestaDate, { fontWeight: 'bold', color: '#DA7027' }]}>
                        Entreprise mieux disante
                      </Text>
                    )}
                  </View>

                  <View style={styles.notesGrid}>
                    <View style={styles.noteItem}>
                      <Text style={styles.noteLabel}>Note Technique&nbsp;
                        <Text style={{ fontSize: 8, color: '#6B7280', marginLeft: "auto", fontStyle: "italic" }}> (55%)</Text>
                      </Text>
                      <Text style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                        {techScore}/10
                      </Text>
                    </View>
                    <View style={styles.noteItem}>
                      <Text style={styles.noteLabel}>Note Financière&nbsp;
                        <Text style={{ fontSize: 8, color: '#6B7280', marginLeft: "auto", fontStyle: "italic" }}> (45%)</Text>
                      </Text>
                      <Text style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                        {finScore.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/10
                      </Text>
                    </View>
                    <View style={styles.noteItem}>
                      <Text style={styles.noteLabel}>Note Totale</Text>
                      <Text style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                        {totalScore.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/10
                      </Text>
                    </View>
                  </View>

                  {isSelected && (
                    <View style={[styles.noteSection, { alignItems: 'center' }]}>
                      <Text style={[styles.noteTitle, { color: '#004681' }]}>
                        Prestataire Sélectionné
                      </Text>
                    </View>
                  )}
                </View>
              );
            })}
          </View>
        </View>

        {/* Pied de page */}
        <Text style={styles.footer}>
          Document généré par Centralis • {today} • {user?.email || ''}
        </Text>
      </Page>
    </Document>
  );
};

export default AnalyseRecapPDF;